import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const contactPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'SEOPower Support',
  description: 'Get help and support for SEOPower. Find answers to common questions or contact our team directly.',
  url: `${siteUrl}/support`,
  mainEntity: {
    '@type': 'Organization',
    name: 'SEOPower',
    url: siteUrl,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: 'support@seopower.co',
    },
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: siteUrl,
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Support',
      item: `${siteUrl}/support`,
    },
  ],
};

export default function SupportPage() {
  return (
    <div className="min-h-screen bg-white">
      <title>Support - SEOPower Help Center | SEOPower.co</title>
      <meta name="description" content="Need help with SEOPower? Find answers to common questions and get support from our team. Contact us at support@seopower.co." />
      <meta name="keywords" content="SEOPower support, SEO tool help, contact SEOPower, SEO analysis help" />
      <link rel="canonical" href={`${siteUrl}/support`} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(contactPageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <Navbar />
      
      {/* Hero Section */}
      <div className="pt-20">
        <div className="bg-gradient-to-b from-[#ede9fe] to-white py-12">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              How Can We Help You?
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Find answers, get support, and connect with our team
            </p>
          </div>
        </div>
        
        {/* FAQ Section */}
        <div className="py-12 bg-white">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-[#E8F5F3] rounded-full">
              <i className="ri-tools-line text-4xl text-[#0A7B83]"></i>
            </div>
            <p className="text-2xl text-gray-600 mb-4">
              Support resources coming soon
            </p>
            <p className="text-lg text-gray-500">
              In the meantime, contact us at{' '}
              <a
                href="mailto:support@seopower.co"
                className="text-[#0A7B83] hover:underline cursor-pointer"
              >
                support@seopower.co
              </a>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}